import React, { useState } from "react";
import gsap from "gsap";

const Navbar = () => {

    const [isOpen, setIsOpen] = useState(false);

    const ToggleBurgerMenu = () => {
        if (isOpen === false) {
            gsap.to(".gsap-text", {opacity:0})
            gsap.to(".gsap-text-1", {opacity:0})

            gsap.fromTo(".gsap-burger-nav", {opacity:0, x:-100},{opacity:1, x:0})

            document.getElementById("burger-menu-buttons").className = "absolute gsap-burger-nav top-0 left-0 opacity-0"
            setIsOpen(true)
        } else {
            gsap.fromTo(".gsap-burger-nav", {opacity:1, x:0},{opacity:0, x:-100})
            gsap.to(".gsap-text", {opacity:1})
            gsap.to(".gsap-text-1", {opacity:1})
            document.getElementById("burger-menu-buttons").className = "absolute gsap-burger-nav top-0 left-0 opacity-0 pass-trough"
            setIsOpen(false)
        }
    }

    return (
        <div class="h-14 bg-color-1 flex  items-center relative navbar">

            <img alt="" class="gsap-text w-10 h-10 ml-12 cursor-pointer" onClick={() => window.location.href = "/loputoo/index.html"} src={require("../assets/icons8-orange-96.png")} />
            <h1 class="gsap-text-1 text-white font-title text-2xl cursor-pointer" onClick={() => window.location.href = "/loputoo/index.html"}>Sunsett Sipper</h1>

            <img alt="burger-menu" onClick={() => ToggleBurgerMenu()} class="burger absolute right-0 w-0 opacity-0" src={require("../assets/burger.png")}></img>

            {/* NAVBAR BUTTONS */}
            <div class="absolute right-10 top-0 flex h-full nav-btns">
                <button id="kodu" class="p-4 nav" onClick={() => window.location.href = "/loputoo/index.html"}>
                    <h2 class="text-white font-sec">Kodu</h2>
                </button>
                <button id="info" class="p-4 nav" onClick={() => window.location.href = "#/info"}>
                    <h2 class="text-white font-sec">Uuri rohkem</h2>
                </button>
                <button id="osta" class="p-4 nav" onClick={() => window.location.href = "#/buy"}>
                    <h2 class="text-white font-sec">Osta</h2>
                </button>
            </div>

            {/* BURGER MENU BUTTONS */}
            <div id="burger-menu-buttons" class="absolute gsap-burger-nav top-0 left-0 opacity-0 pass-trough">
                <button id="kodu" class="p-4 nav" onClick={() => window.location.href = "/loputoo/index.html"}>
                    <h2 class="text-white font-sec">Kodu</h2>
                </button>
                <button id="info" class="p-4 nav" onClick={() => window.location.href = "#/info"}>
                    <h2 class="text-white font-sec">Uuri rohkem</h2>
                </button>
                <button id="osta" class="p-4 nav" onClick={() => window.location.href = "#/buy"}>
                    <h2 class="text-white font-sec">Osta</h2>
                </button>
            </div>
        </div>
    )
}

export default Navbar